@if ((voucher().product?.name | lowercase) === arubaTrustedPlatformName) {
<div class="w-100 m-auto pt-4">
  <mat-card appearance="outlined">
    <mat-card-title class="d-flex align-items-center">
      {{ 'VOUCHER.CREATE.ARUBA_TRUSTED_PLATFORM' | translate }}
    </mat-card-title>
    <mat-card-content>
      <div *userPermission="'VOUCHER_CAN_WRITE'" class="d-flex align-items-center justify-content-end">
        <span class="mr-2 mat-caption">Carica configurazione ARSS (zip):</span>
        <app-file-uploader
          [showFileList]="false"
          [showDndArea]="true"
          [maxNumberOfFiles]="1"
          [extensions]="['.zip']"
          [showValidationErrorMessage]="true"
          [concatenateMultipleFiles]="false"
          [uploadOnFilesDropped]="true"
          [uploadButtonText]="'Carica configurazione'"
          (startUpload)="onStartUploadArssConfig($event)"
        ></app-file-uploader>

        <span class="mr-2 mat-caption">Oppure modifica manualmente:</span>
        <button mat-icon-button class="mr-2" (click)="canModify = !canModify">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      @if (voucher().client_configuration_id) {
      <app-voucher-atp
        [client_configuration_id]="voucher()?.client_configuration_id"
        [canModify]="canModify"
        (formGroupEmit)="formArrayAtp = $event"
      ></app-voucher-atp>
      <div *userPermission="'VOUCHER_CAN_WRITE'" class="w-100 d-flex justify-content-end mt-5">
        @if (formArrayAtp) {
        <button mat-flat-button type="button" color="primary" [disabled]="formArrayAtp.pristine" (click)="saveAtp()">
          {{ 'VOUCHER.ATP.SAVE' | translate }}
        </button>
        }
      </div>
      }
    </mat-card-content>
  </mat-card>
</div>
}
